import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "mainform g-3 pb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12 position-relative formitem_parent" }
const _hoisted_5 = { class: "col-sm-12 position-relative formitem_parent" }
const _hoisted_6 = { class: "col-sm-12 position-relative formitem_parent" }
const _hoisted_7 = { class: "row mt-4 clearfix noprint" }
const _hoisted_8 = { class: "col d-flex justify-content-start flex-row-reverse" }
const _hoisted_9 = ["disabled"]

import {computed, onBeforeMount, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {TranslatedText} from "@/store/types";
import crud from "@/crud";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  setup(__props) {

const store = useStore();
const router = useRouter();

const tempPassword = ref('');
const newPassword = ref('');
const repeatNewPassword = ref('');

const fullname = computed(() => {
  return store.state.i.me.firstname + ' ' + store.state.i.me.lastname;
})

const errorstring = ref<TranslatedText>({de: '', en: ''})
const fieldsFilled = computed(() => tempPassword.value.length > 0 && newPassword.value.length > 0 && newPassword.value === repeatNewPassword.value);

onBeforeMount(async () => {
  if (!store.state.tempPassword) {
    await router.replace({name: 'Welcome'});
  }
});

const checkPasswords = (e: FocusEvent | KeyboardEvent) => {
  if (e.type === 'keyup') {
    // Wenn wir den Fehler bereits zeigen dann auch direkt beim tippen wieder ausblenden wenn es irgendwann passt.
    if (errorstring.value.de != '' && newPassword.value === repeatNewPassword.value) {
      errorstring.value = {de: '', en: ''};
    }
    return;
  }

  if (newPassword.value !== repeatNewPassword.value) {
    errorstring.value = {de: "Passwords don't match", en: "Passwords don't match"};
  } else {
    errorstring.value = {de: '', en: ''};
  }
};

const updatePassword = async () => {
  if (!fieldsFilled.value) {
    return;
  }

  errorstring.value = {de: '', en: ''};

  const changePasswordRes = await crud('/changePassword', {
    jwt: store.state.jwt,
    tempPassword: tempPassword.value,
    newPassword: newPassword.value,
    repeatNewPassword: repeatNewPassword.value,
  });

  if(changePasswordRes.success) {
    store.commit('setTempPassword', false);
    router.replace({ name: changePasswordRes.show_onboarding ? 'Step1' : 'Welcome' })
  } else {
    errorstring.value = {de: changePasswordRes.error ?? '', en: changePasswordRes.error ?? ''};
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Change Password", -1)),
      _createElementVNode("p", null, " Dear " + _toDisplayString(fullname.value) + ", ", 1),
      _cache[7] || (_cache[7] = _createElementVNode("p", null, " please change your password. Please note that the password must contain characters from three of the following four character classes: Upper case letters, lower case letters, numbers. The minimum length is 12 characters. Number sequences (e.g. 1234) and year patterns (e.g. 1990, 2025) are not allowed. ", -1)),
      _withDirectives(_createElementVNode("div", { class: "alert alert-danger mb-5" }, _toDisplayString(_unref(store).getters.i18n(errorstring.value)), 513), [
        [_vShow, errorstring.value.de]
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(updatePassword, ["prevent"]),
          class: "form-horizontal"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("label", {
                class: "form-label",
                for: "musername"
              }, "Temporary password", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                required: "",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tempPassword).value = $event)),
                id: "temppassword",
                class: "form-control"
              }, null, 512), [
                [
                  _vModelText,
                  tempPassword.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                class: "form-label",
                for: "mpassword"
              }, "New Password", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                required: "",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
                id: "password1",
                class: "form-control"
              }, null, 512), [
                [
                  _vModelText,
                  newPassword.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                class: "form-label",
                for: "mpassword"
              }, "New Password (repeat)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                required: "",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeatNewPassword).value = $event)),
                id: "password2",
                class: "form-control",
                onFocusout: checkPasswords,
                onKeyup: checkPasswords
              }, null, 544), [
                [
                  _vModelText,
                  repeatNewPassword.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "btn btn-primary m-2",
                disabled: !fieldsFilled.value,
                type: "submit"
              }, " Submit ", 8, _hoisted_9)
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}
}

})